import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const VarificationCbpRatesPopUp = (props) => {
  const {
    message,
    setVarificationcbpRatesPopUp,
    varificationCbpRatesPopUp,
    setVarificationCbpRatesMessage,
  } = props;

  const handleOk = () => {
    setVarificationcbpRatesPopUp(false);
    setVarificationCbpRatesMessage('');
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={varificationCbpRatesPopUp}>
      <DialogContent dividers>
        <Typography variant='h6'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleOk}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VarificationCbpRatesPopUp;
